export const brandState = state => state.brands;

export const getLoadingBrands = state => brandState(state).loading;

export const getBrand = state => brandState(state).brand;

export const getBrandsLoaded = state => brandState(state).brands;

export const getResponseBrand = state => brandState(state).response;
 